import { useMutation } from '@tanstack/react-query';

import updateBusinessRegNumber, {
  UpdateBusinessRegNumberParams,
} from '~apis/certificates/updateBusinessRegNumber';
import { queryClient } from '~libs/queryClient';

import { USE_BUSINESS_REGISTRATION_NUMBERS_QUERY } from './useBusinessRegistrationNumbers';
import { USE_GET_CERTIFICATES_QUERY } from './useCertificatesQuery';
import { USE_DATA_QUALIFICATIONS_QUERY } from './useDataQualificationsQuery';

export default function useUpdateCertificateBusinessRegNumberMutation() {
  return useMutation(
    ({ companyId, certificateId, businessRegNumber }: UpdateBusinessRegNumberParams) =>
      updateBusinessRegNumber({ companyId, certificateId, businessRegNumber }),
    {
      onSuccess: (_, variables) => {
        const companyId = variables.companyId;
        queryClient.invalidateQueries(USE_GET_CERTIFICATES_QUERY.default(companyId));
        queryClient.invalidateQueries(USE_DATA_QUALIFICATIONS_QUERY.default(companyId));
        queryClient.invalidateQueries(USE_BUSINESS_REGISTRATION_NUMBERS_QUERY.default(companyId));
      },
    },
  );
}
